import React from "react";
import { Drawer } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useIsMobile } from "hooks/use-breakpoint-checks.hook";

export default function RightDrawer({
  children,
  maxWidth = { xs: "100vw", sm: "50vw", xl: "35vw" },
  open = true,
  minWidth = { xs: "100vw", sm: "35vw" },
  onClose = () => {},
}) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          maxWidth,
          minWidth: minWidth,
          height: isMobile ? "93vh" : "100vh",
          borderTopLeftRadius: { xs: 0, sm: theme.shape.borderRadius * 3 },
          borderBottomLeftRadius: { xs: 0, sm: theme.shape.borderRadius * 3 },
          display: "flex",
          flexDirection: "column"
        },
      }}
      SlideProps={{
        style: {
          height: isMobile ? "93vh" : "100vh"
        }
      }}
    >
      {children}
    </Drawer>
  );
}
